import { render } from 'preact';
import { prerender as ssr } from 'preact-iso';
import { App } from './app';
import './styles/tokens.css';
import './styles/base.css';
import { initTheme } from './lib/theme';
import { DEFAULT_TITLE, resetSsrHead, ssrHead } from './lib/meta';

if (typeof window !== 'undefined') {
  initTheme();
  const root = document.getElementById('app')!;
  // Public pages ship prerendered HTML (for crawlers and the first paint).
  // The app renders fresh over it instead of hydrating: legal pages switch to
  // the browser's language and screenshots follow the theme, so the markup
  // can legitimately differ from the build-time English/light render. Clear +
  // render happen in one task, so nothing blank ever paints.
  root.textContent = '';
  render(<App />, root);
}

// Pages worth indexing: the build prerenders these (and follows no other
// links), plus the 404 page and an empty shell for the signed-in routes — see
// mountStatic in backend/internal/http/server.go.
const PUBLIC = ['/', '/changelog', '/privacy', '/terms', '/support', '/delete-account'];
const SHELL_ROUTE = '/_shell';

export async function prerender({ url }: { url: string }) {
  if (url === SHELL_ROUTE) {
    // Signed-in / one-off pages: no content to prerender, never indexed.
    return {
      html: '',
      head: {
        lang: 'en',
        title: DEFAULT_TITLE,
        elements: new Set([{ type: 'meta', props: { name: 'robots', content: 'noindex' } }]),
      },
    };
  }
  resetSsrHead();
  const { html, links } = await ssr(<App />);
  const path = url.replace(/\/$/, '') || '/';
  const elements = new Set<{ type: string; props: Record<string, string> }>([
    { type: 'meta', props: { name: 'description', content: ssrHead.description } },
  ]);
  if (PUBLIC.includes(path)) {
    elements.add({
      type: 'link',
      props: { rel: 'canonical', href: `https://shotmeal.com${path === '/' ? '/' : path}` },
    });
  } else {
    elements.add({ type: 'meta', props: { name: 'robots', content: 'noindex' } });
  }
  return {
    html,
    links: new Set([...(links ?? [])].filter((l) => PUBLIC.includes(l.split('#')[0] || '/'))),
    head: { lang: 'en', title: ssrHead.title, elements },
  };
}
